import {Component, Inject, OnInit} from '@angular/core';
import {AuthenticationService} from '@services/authentification.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';

@Component({
  selector: 'app-pub-open',
  templateUrl: './pub-open.component.html',
  styleUrls: ['./pub-open.component.scss']
})
export class PubOpenComponent implements OnInit {

    user: User = Object.assign({}, EMPTY_USER);
    aiCreditTooltip = 'Décidez plus vite : notre IA analyse l’annonce et le DPE, met en lumière les opportunités, les alertes et les chiffres à vérifier, puis suggère les ajustements utiles pour fiabiliser votre investissement.';

    constructor(
        private authenticationService: AuthenticationService,
        public dialogRef: MatDialogRef<PubOpenComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        dialogRef.disableClose = !this.data.close;
    }

    ngOnInit(): void {
        this.user = this.authenticationService.currentUser;
    }

    onNoClick(): void {
        if (this.data.close == true) {
            this.dialogRef.close("");
        }
    }

    onYesClick(plan): void {
        this.dialogRef.close(plan);
    }
}
